import { FormFeedback, FormGroup, Input, Label } from "reactstrap";

import PropTypes from "prop-types";
import React from "react";

const TextInput = ({
  label,
  type,
  name,
  placeholder,
  error,
  errorMessage,
  style = {},
  containerStyle,
  containerClass = "",
  onChange,
  isView,
  ...props
}) => {
  return (
    <FormGroup style={containerStyle || {}} className={containerClass}>
      {label && <Label className="bold-text">{label}</Label>}
      <Input
        type={type}
        name={name}
        disabled={isView !== undefined ? isView : props.disabled}
        placeholder={placeholder}
        onChange={(e) => (onChange ? onChange(e) : null)}
        style={style}
        invalid={error}
        {...props}
      />
      <FormFeedback>{errorMessage}</FormFeedback>
    </FormGroup>
  );
};

export default TextInput;

TextInput.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  placeholder: PropTypes.string,
  style: PropTypes.object,
  containerStyle: PropTypes.object,
  onChange: PropTypes.func,
  props: PropTypes.any,
  disabled: PropTypes.bool
};
